import { showNotification } from "@mantine/notifications";
import { useEffect, useState } from "react";
import { ChatMessage, FlaggedData } from "src/interfaces/Chat";
import { ChildCreationData, ChildrenData } from "src/interfaces/Children";
import { ProcessedComplaint } from "src/interfaces/Complaints";
import { ResponseKind } from "src/services/services/MainService";
import { adminService } from "src/services/services/admin/admin.api";
import { MessageList } from "src/services/services/chat/chat.api.types";
import { ParentApi, parentService } from "src/services/services/parent/parent.api";

const useComplaints = () => {
const [processedComplaints, setProcessedComplaints] = useState<any[]>([])  
const [childMessages, setChildMessages] = useState<ChatMessage[]>([])  

    useEffect(() => {
        getComplaints()
    }, [])


const resolveComplaint = async (flagMessage: FlaggedData) => {
    const response = await parentService.flagMessage(flagMessage)

    if(response.kind == ResponseKind.OK){
        showNotification({
            message: 'Your message was flagged',
            color: "green",
          });
    }else{
        showNotification({
            message: 'Something went wrong',
            color: "red",
          });
    }
}

const getComplaints = async () => {

    const response = await adminService.getComplaints()
    if(response.kind == ResponseKind.OK && response.data){
        let complaints = response.data.complaints

        const processed_complaints = complaints.map(complaint => {
            const parsedMessages: ChatMessage[] = JSON.parse(complaint.flagged_messages);
            const flaggedMessageIndex = parsedMessages.findIndex(msg => msg.is_flagged);
            
            if (flaggedMessageIndex === -1) {
              console.error(`No flagged message found in complaint ${complaint.id}`);
              return null;
            }
        
            const flaggedMessage = parsedMessages[flaggedMessageIndex];
            const previousMessages = parsedMessages.slice(0, flaggedMessageIndex);
        
            return {
              id: complaint.id,
              parent_email: complaint.parent_email,
              child_username: complaint.child_username,
              flagged_message: flaggedMessage.content,
              feedback: complaint.feedback,
              previous_messages: previousMessages.map(msg => ({
                role: msg.role as "human" | "ai",
                content: msg.content,
                created_at: msg.created_at
              })),
              created_at: complaint.created_at,
              status: complaint.status
            };
        })
        
        setProcessedComplaints(processed_complaints)


    }else{
        showNotification({
            message: 'Something went wrong',
            color: "red",
          });
    }
}

return{
    processedComplaints
}
}

export default useComplaints;